export const LANGUAGE_ENGLISH = 'English';
export const LANGUAGE_ENGLISH_ID = '507f1f77bcf86cd799439023';

export const LANGUAGE_I_PREFER_NOT_TO_ANSWER = 'Prefer Not to Answer';
export const LANGUAGE_I_PREFER_NOT_TO_ANSWER_ID = '507f1f77bcf86cd799439043';

export const LANGUAGE = [
    {label: LANGUAGE_ENGLISH, _id: LANGUAGE_ENGLISH_ID},
    {label: 'Arabic', _id: '507f1f77bcf86cd799439024'},
    {label: 'Cape Verdean', _id: '507f1f77bcf86cd799439025'},
    {label: 'Chinese', _id: '507f1f77bcf86cd799439026'},
    {label: 'Creole', _id: '507f1f77bcf86cd799439027'},
    {label: 'French', _id: '507f1f77bcf86cd799439028'},
    {label: 'Khmer', _id: '507f1f77bcf86cd799439029'},
    {label: 'Portuguese', _id: '507f1f77bcf86cd799439030'},
    {label: 'Russian', _id: '507f1f77bcf86cd799439031'},
    {label: 'Spanish', _id: '507f1f77bcf86cd799439032'},
    {label: 'Vietnamese', _id: '507f1f77bcf86cd799439033'},
    {label: 'Other', _id: '507f1f77bcf86cd799439042'},
    {label: LANGUAGE_I_PREFER_NOT_TO_ANSWER, _id: LANGUAGE_I_PREFER_NOT_TO_ANSWER_ID},
];
